var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUptrendLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 13,
    viewBox: "0 0 33 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 12.0443C1.33325 12.0443 5.47077 7.09052 9.18478 6.35695C12.0089 5.79915 13.6487 7.73611 16.4948 7.30484C20.9019 6.63704 21.7461 1.86694 26.1062 0.940472C28.5366 0.424027 32.3333 0.940458 32.3333 0.940458",
    stroke: "#66C87B",
    strokeWidth: 1.18059,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptrendLine);
export default __webpack_public_path__ + "static/media/uptrend-line.12bc605f4880cade715e63fd30cccdb7.svg";
export { ForwardRef as ReactComponent };